import { SEGMENTS } from '@/components/OnboardingHandlerComponents/AiBuilderCreateSite/AiBuilderCreateSite.enum';

export const SEGMENTS_OPTIONS_LIST_ES = [
  { value: SEGMENTS.ACCOUNTING, label: 'Contabilidad' },
  { value: SEGMENTS.BOOKKEEPING, label: 'Registro contable' },
  { value: SEGMENTS.FINANCIAL_CONSULTING, label: 'Consultoría Financiera' },
  { value: SEGMENTS.ACUPUNCTURE, label: 'Acupuntura' },
  { value: SEGMENTS.CHIROPRACTOR, label: 'Quiropráctico' },
  { value: SEGMENTS.DENTIST, label: 'Dentista' },
  { value: SEGMENTS.DOCTOR, label: 'Médico' },
  { value: SEGMENTS.MASSAGE_THERAPY, label: 'Terapia de Masaje' },
  { value: SEGMENTS.PHYSIOTHERAPY, label: 'Fisioterapia' },
  { value: SEGMENTS.PSYCHOLOGY, label: 'Psicología' },
  { value: SEGMENTS.WELLNESS, label: 'Bienestar' },
  { value: SEGMENTS.YOGA_INSTRUCTION, label: 'Clases de Yoga' },
  { value: SEGMENTS.BARBER_SHOP, label: 'Barbería' },
  { value: SEGMENTS.BEAUTY, label: 'Belleza' },
  { value: SEGMENTS.HAIR_STYLIST, label: 'Peluquería' },
  { value: SEGMENTS.MAKEUP_ARTIST, label: 'Maquillador' },
  { value: SEGMENTS.BAKERY, label: 'Panadería' },
  { value: SEGMENTS.CAFE, label: 'Cafetería' },
  { value: SEGMENTS.CATERING, label: 'Servicio de Catering' },
  { value: SEGMENTS.CHEF, label: 'Chef' },
  { value: SEGMENTS.COFFEE_SHOP, label: 'Cafetería' },
  { value: SEGMENTS.FAST_FOOD, label: 'Comida Rápida' },
  { value: SEGMENTS.PIZZA_RESTAURANT, label: 'Pizzería' },
  { value: SEGMENTS.RESTAURANT, label: 'Restaurante' },
  { value: SEGMENTS.BUSINESS_CONSULTING, label: 'Consultoría Empresarial' },
  { value: SEGMENTS.CAREER_COACHING, label: 'Coaching Profesional' },
  { value: SEGMENTS.COACHING, label: 'Coaching' },
  { value: SEGMENTS.CONSULTING, label: 'Consultoría' },
  { value: SEGMENTS.COUNSELLING, label: 'Consejería' },
  { value: SEGMENTS.EDUCATION, label: 'Educación' },
  { value: SEGMENTS.IT_CONSULTING, label: 'Consultoría de TI' },
  { value: SEGMENTS.LAW_FIRM, label: 'Bufete de Abogados' },
  { value: SEGMENTS.PROJECT_MANAGEMENT, label: 'Gestión de Proyectos' },
  { value: SEGMENTS.PUBLIC_RELATIONS, label: 'Relaciones Públicas' },
  { value: SEGMENTS.RESUME_WRITING, label: 'Redacción de currículum (CV)' },
  { value: SEGMENTS.SOCIAL_MEDIA_MARKETING, label: 'Marketing en Redes Sociales' },
  { value: SEGMENTS.TRANSLATION, label: 'Traducción' },
  { value: SEGMENTS.AUDIO_EDITING, label: 'Edición de Audio' },
  { value: SEGMENTS.AUDIO_PRODUCTION, label: 'Producción de Audio' },
  { value: SEGMENTS.CONTENT_WRITING, label: 'Redacción de Contenido' },
  { value: SEGMENTS.COPYWRITING, label: 'Redacción Publicitaria' },
  { value: SEGMENTS.DESIGN, label: 'Diseño' },
  { value: SEGMENTS.DEVELOPMENT_AND_DESIGN, label: 'Desarrollo y Diseño' },
  { value: SEGMENTS.DIGITAL_MARKETING, label: 'Marketing Digital' },
  { value: SEGMENTS.GRAPHIC_DESIGN, label: 'Diseño Gráfico' },
  { value: SEGMENTS.ILLUSTRATING, label: 'Ilustración' },
  { value: SEGMENTS.MARKETING, label: 'Marketing' },
  { value: SEGMENTS.PHOTOGRAPHY, label: 'Fotografía' },
  { value: SEGMENTS.VIDEO_EDITING, label: 'Edición de Video' },
  { value: SEGMENTS.VIDEO_PRODUCTION, label: 'Producción de Video' },
  { value: SEGMENTS.WRITING, label: 'Escritura' },
  { value: SEGMENTS.PROPERTY_MANAGEMENT, label: 'Administración de inmuebles' },
  { value: SEGMENTS.REAL_ESTATE, label: 'Bienes Raíces' },
  { value: SEGMENTS.REAL_ESTATE_AGENCY, label: 'Agencia Inmobiliaria' },
  { value: SEGMENTS.COMPUTER_REPAIR, label: 'Reparación de Computadoras' },
  { value: SEGMENTS.MOBILE_REPAIR, label: 'Reparación de Celulares' },
  { value: SEGMENTS.SOFTWARE_DEVELOPMENT, label: 'Desarrollo de Software' },
  { value: SEGMENTS.UI_UX_DESIGN, label: 'Diseño UI/UX' },
  { value: SEGMENTS.WEB_DESIGN, label: 'Diseño Web' },
  { value: SEGMENTS.WEB_DEVELOPMENT, label: 'Desarrollo Web' },
  { value: SEGMENTS.CAR_DETAILING, label: 'Estética automotriz ' },
  { value: SEGMENTS.CAR_RENTALS, label: 'Alquiler de Carros' },
  { value: SEGMENTS.ELECTRIC_VEHICLES, label: 'Vehículos Eléctricos' },
  { value: SEGMENTS.EV_RENTALS, label: 'Alquiler de Vehículos Eléctricos' },
  { value: SEGMENTS.MECHANIC, label: 'Mecánico' },
  { value: SEGMENTS.TAXI, label: 'Taxi' },
  { value: SEGMENTS.TRUCKING, label: 'Transporte carretero' },
  { value: SEGMENTS.CLEANING, label: 'Limpieza' },
  { value: SEGMENTS.CARPET_CLEANING, label: 'Limpieza de Alfombras' },
  { value: SEGMENTS.ELECTRICIAN, label: 'Electricista' },
  { value: SEGMENTS.GARDENING, label: 'Jardinería' },
  { value: SEGMENTS.HANDYMAN, label: 'Reparaciones del hogar' },
  { value: SEGMENTS.HOUSE_CLEANING, label: 'Limpieza de Casas' },
  { value: SEGMENTS.LANDSCAPING, label: 'Paisajismo' },
  { value: SEGMENTS.LAWN_CARE, label: 'Cuidado del Césped' },
  { value: SEGMENTS.PAINTING, label: 'Pintura' },
  { value: SEGMENTS.PLUMBING, label: 'Plomería ' },
  { value: SEGMENTS.POOL_CLEANING, label: 'Limpieza de Piscina' },
  { value: SEGMENTS.PRESSURE_WASHING, label: 'Lavado a Presión' },
  { value: SEGMENTS.DOG_TRAINING, label: 'Adiestramiento de perros' },
  { value: SEGMENTS.DOG_WALKING, label: 'Paseo de Perros' },
  { value: SEGMENTS.PET_SITTING, label: 'Cuidado de Mascotas' },
  { value: SEGMENTS.FITNESS, label: 'Fitness' },
  { value: SEGMENTS.PERSONAL_TRAINING, label: 'Entrenamiento Personal' },
  { value: SEGMENTS.SPORTS_INSTRUCTION, label: 'Instrucción Deportiva' },
  { value: SEGMENTS.DJ, label: 'DJ' },
  { value: SEGMENTS.EVENT_PLANNING, label: 'Planificación de Eventos' },
  { value: SEGMENTS.ONLINE_ENTERTAINMENT, label: 'Entretenimiento online' },
  { value: SEGMENTS.ONLINE_STORE, label: 'Tienda online' },
  { value: SEGMENTS.RETAIL_STORE, label: 'Tienda física' },
  { value: SEGMENTS.SOLAR_INSTALLATION, label: 'Instalación Solar' },
  { value: SEGMENTS.BIKE_MECHANIC, label: 'Mecánico de Bicicletas' },
  { value: SEGMENTS.BOAT_DETAILING, label: 'Estética Náutica' },
  { value: SEGMENTS.CONSTRUCTION, label: 'Construcción' },
  { value: SEGMENTS.FOOD_DELIVERY, label: 'Entrega de Comida' },
  { value: SEGMENTS.INFLUENCE_MARKETING, label: 'Marketing de Influencers' },
  { value: SEGMENTS.INSURANCE_BROKER, label: 'Corredor de Seguros' },
  { value: SEGMENTS.INTERIOR_DESIGN, label: 'Diseño de Interiores' },
  { value: SEGMENTS.LOCKSMITH, label: 'Cerrajero' },
  { value: SEGMENTS.MUSIC_INSTRUCTION, label: 'Clases Musical' },
  { value: SEGMENTS.ONLINE_LEARNING, label: 'Aprendizaje online' },
  { value: SEGMENTS.PEST_CONTROL, label: 'Control de Plagas' },
  { value: SEGMENTS.SECURITY, label: 'Seguridad' },
  { value: SEGMENTS.TRAVEL_AGENCY, label: 'Agencia de Viajes' },
  { value: SEGMENTS.YOUTUBER, label: 'YouTuber' },
];
